import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import PurchaseMethodModule from 'features/biller/implementations/stripe/PurchaseMethodModule';
import { Price } from 'features/biller/implementations/stripe/PurchaseMethodModule/PurchaseMethodModuleView';

import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useTrackUxOnMount } from 'util/uxEvents';

interface CheckoutProps {
  price: Price;
  subscriptionType: string;
  onSuccess: () => void;
  onLoading: (isLoading: boolean) => void;
  selectedProductUuid?: string | null | undefined;
}

const Checkout = ({
  price,
  subscriptionType,
  onSuccess,
  onLoading,
  selectedProductUuid,
}: CheckoutProps) => {
  useTrackUxOnMount(EVENT_ACTIONS.SIDE_DRAWER_VIEWED, TRACK_ACTION_TYPES.VIEW, {
    stage: 'checkout_started',
  });

  return (
    <Box mb={32} flex column gap={24}>
      <PurchaseMethodModule
        onSuccess={onSuccess}
        onLoading={onLoading}
        price={price}
        subscriptionType={subscriptionType}
        selectedProductUuid={selectedProductUuid}
      />

      <Text
        variant="bodySm"
        color="mono900"
        i18n="checkout_drawer.footer_text"
        asHTML
      />
    </Box>
  );
};

export default Checkout;
